import RuleModel from './rule-model';

export default class BindModel extends RuleModel {
    hydrate(fields) {
        super.hydrate(fields);
        this.final = false;
    }

    getPayload() {
        const result = super.getPayload();
        Reflect.deleteProperty(result, 'final');
        return result;
    }

    /* eslint-disable */
    get isBind() {
        return true;
    }
    /* eslint-enable */
}
